import { useContext, useCallback, useEffect } from "react";
import uuid from "react-uuid";
import FetchContext from "../../../../contexts/fetch";
import FlowContext from "../../../../contexts/flowContext";
import NotificationContext from "../../../../contexts/notification";
import UserContext from "../../../../contexts/user";

export default function useOnSaveFlow() {
  const [, notificationDispatcher] = useContext(NotificationContext);
  const [, fetchDispatcher] = useContext(FetchContext);
  const [flowState, flowDispatcher] = useContext(FlowContext);
  const [userState] = useContext(UserContext);

  const onSave = useCallback(() => {
    if (flowState.rfInstance) {
      let flow = flowState.rfInstance.toObject();
      const nodes = flow.nodes.map((node) => {
        const { handleBounds, selected, ...rest } = node;
        return {
          ...rest,
        };
      });
      const edges = flow.edges.map((edge) => {
        const { selected, animated, ...rest } = edge;
        return {
          ...rest,
        };
      });

      const viewport = flow.viewport;
      const { _id, rfInstance, ...flowData } = flowState;

      if (!flowData.app) {
        flowData.app = userState.currentApp;
      }
      if (!flowData.brand) {
        flowData.brand = userState.currentBrand;
      }
      if (!flowData.name) {
        flowData.name = userState.currentFlowName;
      }
      if (!flowData.version) {
        flowData.version = userState.currentVersion;
      }

      fetchDispatcher({
        type: "fetch-save-flow",
        brand: userState.currentBrand,
        flowId: _id,
        app: userState.currentApp,
        flow: {
          ...flowData,
          nodes,
          edges,
          viewport,
        },
        onSuccess: (msg, flowId) => {
          notificationDispatcher({
            type: "notify",
            notification: {
              id: uuid(),
              type: "success",
              message: msg,
              duration: 3000,
            },
          });
          flowDispatcher({
            type: "update-flow-data",
            key: "_id",
            value: flowId,
          });
          fetchDispatcher({
            type: "fetch-flow-list",
            app: userState.currentApp,
          });
        },
        onError: (msg) => {
          notificationDispatcher({
            type: "notify",
            notification: {
              id: uuid(),
              type: "failure",
              message: msg,
              duration: 3000,
            },
          });
        },
      });
    }
  }, [
    flowState,
    fetchDispatcher,
    notificationDispatcher,
    userState,
    flowDispatcher,
  ]);

  return { onSave };
}
